import React from 'react';
import withIcon from '../utilities/withIcon';

const IconShareIOS = () => {
  return (
    <g>
      <path d="m14.2988 6.5522h-3.6826a.75.75 0 0 0 0 1.5h2.9326v6.36h-11.0976v-6.36h2.9326a.75.75 0 0 0 0-1.5h-3.6826a.75.75 0 0 0 -.75.75v7.86a.75.75 0 0 0 .75.75h12.5976a.75.75 0 0 0 .75-.75v-7.86a.75.75 0 0 0 -.75-.75z" />
      <path d="m5.22 4.6768 2.03-2.03v7.9049a.75.75 0 0 0 1.5 0v-7.9048l2.03 2.03a.75.75 0 1 0 1.0605-1.0605l-3.3105-3.3102a.7527.7527 0 0 0 -1.0605 0l-3.3106 3.31a.75.75 0 0 0 1.0611 1.0606z" />
    </g>
  );
};

export default withIcon(IconShareIOS);
